<div class="user-status ds-color--black">
  <span class="user-state">
    <dcp-lead-form-login
      [transactionType]="transactionType"
      [transactionListCta]="transactionListCta"
      class="mt-lg-4"></dcp-lead-form-login>
  </span>
  <span *ngIf="(authService.isUserLoggedIn() | async) === true as isLoggedIn">
    <ng-container *ngIf="isLoggedIn">
      <div class="d-inline-block">
        <span class="ds-profile-placeholder d-inline-block align-middle lead-form-profile-icon"
              data-cy="profile-placeholder">
        </span>
        <span class="ps-2">{{'leadForm.options.loggedInAs' | cxTranslate}}&nbsp;</span>
      </div>
      <ng-container *ngIf="user">
        <span data-cy="user-name">{{user.name}}&nbsp;</span>
        <span *ngIf="user?.scimUserId" class="ds-color--grey-2" data-cy="user-id">({{user.scimUserId}})&nbsp;</span>
      </ng-container>
      <a (click)="authService.logout();launchDialogService.closeDialog('Cross click');clearAllData()"
         class="focusable focusable__element offset-none"
         href="javascript:void(0)">
        {{'leadForm.options.logOut' | cxTranslate}}
      </a>
    </ng-container>
 </span>
</div>
<div *ngIf="sapEmployeeSubject.value && user" class="mt-3 mt-lg-4 mb-5" data-cy="your-details">
  <h5 class="block-header mb-4">{{'leadForm.sections.yourDerails' | cxTranslate}}</h5>
  <dl>
    <dt data-cy="user-name">{{'leadForm.userInfo.name' | cxTranslate}}:</dt>
    <dd>{{user.name}}</dd>
    <ng-container *ngIf="user.defaultAddress && user.defaultAddress.phone">
      <dt data-cy="user-phone">{{'leadForm.userInfo.phone' | cxTranslate}}:</dt>
      <dd>{{user.defaultAddress.phone}}</dd>
    </ng-container>
    <dt data-cy="user-email">{{'leadForm.fields.email' | cxTranslate}}:</dt>
    <dd>{{user.email}}</dd>
  </dl>
</div>
<div *ngIf="sapEmployeeSubject.value">
  <h5 class="block-header mb-4">{{'leadForm.sections.customerDetails' | cxTranslate}}</h5>
  <ngb-alert [dismissible]="false" type="info">
    {{'leadForm.customerDetails' | cxTranslate}}
  </ngb-alert>
</div>
